(() => {
  let count = 0;
  function switcher() {
    const deSwitcher = qsa(".ly-flag-icon-de-de");
    const countrySwitchersContainer = qsa("[id*='countrySwitcherList-']");
    const countrySwitchers = qsa(".geolocation [id*='countrySwitcherList-'] li[key]");
    const currentText = qsa('[aria-controls*="countrySwitcherList-"] .ly-custom-dropdown-current-inner-text');
    const close = qs('.js-geolocation__close');
    const footerCountrySwitchers = qsa('.footer [id*="countrySwitcherList-"] li');
    const langHeaderSwitchers = qsa('.header__language [id*="languagesSwitcherList-"] li');
    const langSwitchers = qsa('.geolocation [id*="languagesSwitcherList-"] li');
    const submitBtn = qs('.geolocation .ly-submit-btn');
    
    if(submitBtn && qs('.js-geolocation [data-go-label]')) {
      submitBtn.innerText = qs('.js-geolocation [data-go-label]').dataset.goLabel;
    }

     countrySwitchersContainer.forEach(item => {
       if(item.querySelector('[key="GB-EUR"]') == null) {
        var result = window.location.pathname + window.location.search;
        const params = new URLSearchParams(window.location.search);
        const hasUTM = params.get('utm_source') === 'QR' && params.get('utm_medium') === 'QRCode';
        const firstSegment = window.location.pathname.split('/')[1];

        if (firstSegment.includes('-') && firstSegment.length == 5) {
          const parts = window.location.pathname.split('/').filter(Boolean);

          if (/^[a-z]{2}-[a-z]{2}$/i.test(parts[0])) {
            parts.shift();
          }

          result = '/' + parts.join('/') + window.location.search;
        }

        item.insertAdjacentHTML('beforeend', `
          <li key="GB-EUR"><a class="ly-custom-dropdown-list-element" id="pyrex_uk_option" href="https://pyrex.co.uk/" data-currency-code="EUR" data-country-code="GB" rel="nofollow"><span class="ly-inner-text">UK (GBP £)</span></a></li>
        `)

        if (hasUTM) {
          document.getElementById('pyrex_uk_option').href = `https://www.pyrex.co.uk${result}`;
        }
       }
    })

    if(langSwitchers) {
        langSwitchers.forEach(item => {
          const link = qs('a', item);
          link && link.addEventListener('click', e => {
            setTimeout(() => {
              langSwitchers.forEach(el => {
                el.classList.remove('current');
              })
              item.classList.add('current');
            }, 100)
            setTimeout(() => {
              if(item.classList.contains('current')) {
                const geoCurrentKey = item.getAttribute('key');
                if(geoCurrentKey == 'gb' || geoCurrentKey == 'fr') {
                  submitBtn && submitBtn.addEventListener('click', function() {
                    const headerCurrentCountry = qs('.header [id*="countrySwitcherList-"] li.current a');
                    if(headerCurrentCountry) headerCurrentCountry.click();
                  });
                } else {
                  const franceTrans = ['Frankreich', 'France', 'Francia', 'Frankrijk'];
                  const geoCurrentCountry = qs('.geolocation [aria-controls*="countrySwitcherList"] .ly-custom-dropdown-current-inner-text');
                  const geoText = geoCurrentCountry.innerText.split(' ')[0];
                  submitBtn && submitBtn.addEventListener('click', function() {
                    const headerCurrentLanguage = qs(`.header [id*="languagesSwitcherList-"] li[key="${geoCurrentKey}"] a`);
                    if(franceTrans.indexOf(geoText) > -1 || geoCurrentCountry.innerText.indexOf('UK') > -1) {
                      const headerCurrentCountry = qs('.header [id*="countrySwitcherList-"] li.current a');
                      if(headerCurrentCountry) headerCurrentCountry.click();
                    } else {
                      if(headerCurrentLanguage) headerCurrentLanguage.click();
                    }
                  });
                }
              }
            }, 200);
          })
        })
      }
    
    if(footerCountrySwitchers) {
      footerCountrySwitchers.forEach(item => {
        const link = item.querySelector('a');
        link && link.addEventListener('click', e => {
          const itemChild = item.closest('.ly-switcher-wrapper');
          if(itemChild.querySelector('.ly-submit-btn')) {
            setTimeout(() => {
              if(item.getAttribute('key').indexOf('FR-') > -1 || 
               item.getAttribute('key').indexOf('MC-') > -1 || 
               item.getAttribute('key').indexOf('GB-') > -1) {
              } else {
                itemChild.querySelector('.ly-submit-btn').click();
              }
            }, 100)
          }
        })
      })
    }

    if(langHeaderSwitchers) {
      langHeaderSwitchers.forEach(item => {
        const link = item.querySelector('a');
        link && link.addEventListener('click', e => {
          const itemChild = item.closest('.ly-switcher-wrapper');
          if(itemChild.querySelector('.ly-submit-btn')) {
            setTimeout(() => {
              itemChild.querySelector('.ly-submit-btn').click();
            }, 100)
          }
        })
      })
    }

    if(deSwitcher) {
      deSwitcher.forEach(item => {
        item.classList.add('ly-flag-icon-de');
      })
    }
 
    // if(countrySwitchers) {
    //   countrySwitchers.forEach(item => {
    //     const link = qs('a', item);
    //     if(item.getAttribute('key').indexOf('FR-') > -1 || 
    //     item.getAttribute('key').indexOf('MC-') > -1) {
    //       link.setAttribute('href', 'https://pyrex.fr');
    //     }

    //     link.addEventListener('click', e => {
    //       const footerCurrentLanguage = qs('.footer [id*="countrySwitcherList-"] li.current a');
    //       close && close.addEventListener('click', function() {
    //         const currentLang = qs('.header [id*="languagesSwitcherList-"] li.current_lang a');
    //         if(currentLang) { // okay for eu
    //           currentLang.click();
    //         } else {
    //           if(footerCurrentLanguage) footerCurrentLanguage.click();
    //         }
    //       });
    //     })
        
    //     setTimeout(() => {
    //       if(item.classList.contains('current')) { // okay for eu
    //         const currentCountry = qs('.header [id*="countrySwitcherList-"] li.current a');
    //         if(currentCountry) {
    //           if(currentCountry.dataset.countryCode === 'FR' || 
    //           currentCountry.dataset.countryCode === 'MC') { // France
    //             currentCountry.setAttribute('href', 'https://pyrex.fr');
    //             close && close.addEventListener('click', function() {
    //               currentCountry.click();
    //             });
    //           } 
    //           if(currentCountry.dataset.countryCode === 'GB') { // UK
    //             currentCountry.setAttribute('href', 'https://pyrex.co.uk');
    //              close && close.addEventListener('click', function() {
    //               currentCountry.click();
    //             });
    //           } 
    //         }
    //       }
          
    //       close && close.addEventListener('click', function() {
    //         const currentLang = qs('.header [id*="languagesSwitcherList-"] li.current_lang a'); // specific market
    //         if(currentLang) {
    //           currentLang.click();
    //         }
    //       }); 
    //     }, 300);

    //    if(item.getAttribute('key').indexOf('FR-') > -1 && qs('html[data-country-code="FR"]') ||
    //       item.getAttribute('key').indexOf('GB-') > -1 && qs('html[data-country-code="FR"]')) {
    //       if(item.classList.contains('current')) {
    //         let isLinkClicked = false;
    //         link.addEventListener('click', e => {
    //           isLinkClicked = true;
    //         });
    //         if(!isLinkClicked) {
    //            submitBtn && submitBtn.addEventListener('click', e => {
    //             const currentCountry = qs('.geolocation [id*="countrySwitcherList-"] li.current a');
    //              if(currentCountry) {
    //               currentCountry.click();
    //             }
    //           });
    //         }
    //       }
    //     }
    //   });
    // }

    if(countrySwitchers.length < 1 && count <= 1) {
      setTimeout(() => {
       count = count+1;
       switcher();
      }, 500);
    } 
  } 
  switcher();
})();